import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ReportingActions from '@reporting/reporting.actions';
import * as fromReporting from '@reporting/reporting.reducers';

import { NotificationAttributes } from '@shared/models/Reporting';
import { ReportingService } from '@shared/services/reporting.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-super-human-survey-box',
  templateUrl: './super-human-survey-box.component.html',
  styleUrls: ['./super-human-survey-box.component.scss'],
  standalone: false
})
export class SuperHumanSurveyBoxComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() superhuman: NotificationAttributes;
  @Input() notificationId: number;
  surveyNotStarted: boolean;

  constructor(
    private store: Store,
    private reportingService: ReportingService,
    private trackingService: TrackingService
  ) {
    this.store.pipe(select(fromReporting.selectSuperhuman), takeUntil(this.onDestroy$)).subscribe((value) => {
      const { survey } = value;
      if (!survey?.length) {
        this.surveyNotStarted = true;
        return;
      }

      const answers = survey.filter((question) => question.survey_customer_answer);
      this.surveyNotStarted = !answers.length;
    });
  }

  ngOnInit(): void {
    this.store.dispatch(ReportingActions.fetchSuperhumanSurvey());
  }

  trackCTA(action: string): void {
    this.trackingService.trackActivity(action, true);
  }

  ignoreSurvey(): void {
    this.trackCTA('Superhuman Survey: [Link] Rejected to start/continue');
    this.store.dispatch(ReportingActions.ignoreSuperhumanSurvey({ notificationId: this.notificationId }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
